import { useEffect } from 'react';
import PropTypes from 'prop-types';

const ScriptContainer = ({ order }) => {
    useEffect(() => {
        if (order && order.id !== undefined) {
            initGooglePayTagScript();
        }
    }, [order]);

    const initGooglePayTagScript = () => {
        if (document.getElementById('google-pay-sdk')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'google-pay-sdk';
        script.src = 'https://pay.google.com/gp/p/js/pay.js';
        script.async = true;
        document.body.appendChild(script);
    };

    return null;
};

ScriptContainer.propTypes = {
    order: PropTypes.object
};

export default ScriptContainer;



// WEBPACK FOOTER //
// ./src/components/funnel/ScriptContainer.js